module.exports = __webpack_public_path__ + "static/media/olli-logo.0fe1bbd0.svg";